import React, { Component } from 'react';
import './index.scss';
import { getIsExpiredDate } from '@/utils/DateHelper';
import { POINT_UI_EXPIRED_DATE } from '@/utils/Global';

class BottomSection extends Component {
    renderLeftSection = () => {
        const { value } = this.props

        let src = ''
        switch (value) {
            case 'ko':
                src = 'https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/11ko_encoded.mp4'
                break

            case 'jp':
                src = 'https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/11jp_encoded.mp4'
                break

            default:
                src = 'https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/11en_encoded.mp4'
                break
        }

        return <video autoPlay loop muted src={src} />
    }

    renderMiddleSection = () => {
        const { value } = this.props

        let src = ''
        let onClick
        
        switch (value) {
            case 'ko':
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/k-voucher-banner.png'
                onClick = () => window.open('https://www.k-voucher.kr/index.php/page/productSearch?mode=update&seq=913')
                break

            case 'jp':
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/gettyImageBanner_JP.jpg'
                break

            default:
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/gettyImageBanner_EN.jpg'
                break
        }

        return <img src={src} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }} alt='' />
    }

    renderRightSection = () => {
        const { value } = this.props

        let src = ''
        let onClick = () => {
            this.props.history.push({
                pathname: '/useguide',
                state: {
                    whichMenu: 'point'
                }
            })
        }

        switch (value) {
            case 'ko':
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/pointshopEventBanner_ko.jpg'
                break

            case 'jp':
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/pointshopEventBanner_jp.jpg'
                break

            default:
                src = 'https://front.videomonster.com/images-u6yd72dy/web/main/banner/pointshopEventBanner_en.jpg'
                break
        }

        return <img src={src} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }} alt='' />
    }
    
    render() {
        return (
            <div className="old-bottom-section-root-container">
                <div className="banner-wrap">
                    <div className="banner-relative-wrap">
                        <div>{this.renderLeftSection()}</div>
                        <div>{this.renderMiddleSection()}</div>
                        {   
                            getIsExpiredDate(POINT_UI_EXPIRED_DATE) && 
                                <div>{this.renderRightSection()}</div>
                        }

                        <img className="icon-1" src="https://front.videomonster.com/images-u6yd72dy/web/home/bottom-section-icon1.svg" alt="" />
                        <img className="icon-2" src="https://front.videomonster.com/images-u6yd72dy/web/home/bottom-section-icon2.svg" alt="" />
                    </div>
                </div>
            </div>
        );
    }
}

export default BottomSection